import { makeStyles } from '@material-ui/core';
import React, { useCallback,useState } from 'react';
import PlannerCard from './PlannerCard';
import { useDrop } from 'react-dnd'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { ITripPlannerValues } from '../types/locationTypes';
import { createNewPlanner } from './plannerHelpers';
import update from 'immutability-helper'
import { ItemTypes } from '../../../common/dndHelper'
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox,
     DialogTitle,
    InputAdornment
} from '@material-ui/core';
import { useFormContext, Controller,useForm } from "react-hook-form";
import { ReactComponent as CloseIconSvg } from "../../../assets/icons/pcr/close.svg";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import api from "../../../store/api";
import { getDataFromStorage } from '../../../common/sessionStorageHelpers';
import { persistName } from '../../Schedule/helpers/transferScheduleHelpers';

const useStylesPopUp = makeStyles((theme) => ({
    dialog: {
        '& .MuiPaper-root': {
            //
        },
        '& .MuiDialogTitle-root': {
            fontSize: 18,
            fontWeight: 400,
            color: "#474747",
            margin: 0,
            padding: theme.spacing(3),
            '& .MuiIconButton-root': {
                padding: 0,
                margin: 0,
            },
            '& .closeButton': {
                float: "right",
                '& svg': {
                    height: "14px",
                },
            },
        },
        '& .MuiDialogContent-root': {
            margin: 0,
            padding: theme.spacing(3),
        },
    },
    formContainer: {
        '& .MuiFormControlLabel-label': {
            fontSize: 16,
        },
    },
    formControlLabel: {
        fontSize: 14,
        fontWeight: 600,
        color: "#A8A8A8",
        padding: theme.spacing(0, 0, 1, 0),
        textTransform: "uppercase",
    },
    selectField: {
        fontSize: 16,
        backgroundColor: "#E5E5E5",
        height: "44px",
        width: "100%",
        borderRadius: "4px",
        '& .MuiSelect-selectMenu': {
            fontSize: 16,
        },
        '& img': {
            paddingRight: "15px",
        },
    },
    submitBtn: {
        width: "120px",
        minWidth: 0,
        //height: "40px",
    },
}));

interface SelectItem  {
    text: string | undefined;
    value: string | undefined;
    selected: boolean;
    deleted: boolean;
  }
  interface SelectItemplanners  {
    text: string | undefined;
    value: string | undefined;
    selected: boolean;
    deleted: boolean;
  }
  const defaultValues = {
   
};
const Popup = ({ popState,setPopState,locationid,getEditItemData}: any): JSX.Element => {
    const classes = useStylesPopUp();
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [location, setlocation] = React.useState<SelectItem[]>([]);
    const [locationdefault, setlocationdefault] = React.useState("0");
    const [Planners, setPlanners] = React.useState<SelectItemplanners[]>([]);
    const [Plannersdefault, setPlannersdefault] = React.useState("0");
    const {
        trigger: trigger,
        errors: errors,
        control: control,
        getValues: getValues,
        reset: reset
    } = useForm({
        defaultValues: defaultValues,
    });
    React.useEffect(() => {
        loadData();

    }, [popState])
    const handleClose = (): void => {
        setPopState(!popState);
        setErrorMessage("");      
    }
    const loadData = async (): Promise<void> => {
        try {
            setPlanners([]);
            setErrorMessage("");  
            await getlocationData();
        }
        catch (error) {
            console.error(error);
        }
    }
    const getlocationData = async (): Promise<void> => {
        try {
            const resdata = await api.getLocations('');
            setlocation(resdata.data.model);
        }
        catch (error) {
            //console.log(error); 
        }
    }
    const getplanners = async (value:any): Promise<void> => {
        try {
            setPlanners([]);
            const val = await api.getPlannerByLocation("Locationid="+value);
            setPlanners(val.model);                
        }
        catch (error) {
            //console.log(error); 
        }
    }
    const handletripsave = async (): Promise<void> =>{
        //setErrorMessage("");
        const validate = await trigger();
        if(validate)
        {     
        setStatusMessage("");
        try {
          let values = getValues();
          const _res = await api.addSharedtrip("Locationid="+values["location"] + "&Tripid="+values["planner"]+ "&role="+values["SharingRole"]+ "&RefLocationId="+locationid);
          if (_res !== null) {
            if(_res.locationId!=null)
            {
               handleClose();
               getEditItemData();
            }
            else{
                setErrorMessage("The trip planner is already shared");
                setLoading(false);
            }
          }
        } catch (error) {
          setErrorMessage("Error happened while Sharing location");
          setLoading(false);
        }
       }
    }
    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    return (
        <Dialog
            open={popState}
            onClose={handleClose}
            className={classes.dialog}
        >
            <DialogTitle disableTypography>
                Add  Planner From Another Location
                <IconButton className={"closeButton"} onClick={handleClose}>
                    <CloseIconSvg />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container className={classes.formContainer} spacing={3}>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        Location
                    </div>
                    <Controller
                        name="location"
                        control={control}
                        defaultValue={locationdefault}
                        render={({ onChange, value, name }) => (
                            <FormControl fullWidth error={errors.location}>
                                <Select
                                    onChange={e => {
                                        onChange(e)                               
                                        getplanners(e.target.value);
                                    }}
                                    defaultValue={locationdefault}
                                    value={value}
                                    name={name}
                                    className={classes.selectField}
                                    IconComponent={KeyboardArrowDownIcon}
                                    displayEmpty
                                    fullWidth={true}
                                    variant="outlined"
                                    required                               
                                    error={errors.location}
                                >
                                    <MenuItem key="None" defaultValue='0'value='0'>Choose Location</MenuItem >
                                    {
                                        location.filter(item => item.deleted != true && item.value!=locationid).map(item => <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>{item.text}</MenuItem >)
                                    }
                                </Select>
                                <FormHelperText>{errors.location ? errors.location.message : ""}</FormHelperText>
                            </FormControl>
                        )}
                        rules={{
                            
                            validate: (value) => {
                                if (value === null || value === '' || value === '0') {
                                    return "Location is required"
                                }
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        Planners
                    </div>
                    <Controller
                        name="planner"
                        control={control}
                        defaultValue={Plannersdefault}
                        render={({ onChange, onBlur, value, name }) => (
                            <FormControl fullWidth error={errors.planner}>
                                <Select
                                    onChange={e => {
                                        onChange(e)
                                    }}
                                    defaultValue={Plannersdefault}
                                    value={value}
                                    name={name}
                                    className={classes.selectField}
                                    IconComponent={KeyboardArrowDownIcon}
                                    displayEmpty
                                    fullWidth={true}
                                    variant="outlined"
                                    required
                                >
                                    <MenuItem key="None" defaultValue='0'value='0'>Choose Planner</MenuItem >
                                    {
                                     Planners.filter(item => item.deleted != true).map((item,index) => 
                                      <MenuItem selected={item.selected} key={item.value} defaultValue={item.value} value={item.value}>{item.text !=="" && item.text !==null?item.text :
                                      alphabet.charAt(index)}</MenuItem >)
                                  
                                    }
                                </Select>
                                <FormHelperText>{errors.planner ? errors.planner.message : ""}</FormHelperText>
                            </FormControl>
                        )}
                        rules={{
                            validate: (value) => {
                                if (value === null || value === '' || value === '0') {
                                    return "Planner is required"
                                }
                            }
                        }}
                    />
                </Grid> 
                <Grid item xs={12} sm={12}>
                    <div className={classes.formControlLabel}>
                        Sharing Role
                    </div>
                    <Controller
                        name="SharingRole"
                        control={control}
                        defaultValue=""
                        render={({ name, onBlur, onChange, value }) => (
                            <FormControl fullWidth error={errors.SharingRole}>
                                <RadioGroup
                                    row
                                    value={value}
                                    onChange={(e: any) => { onChange(e) }}
                                >
                                    <FormControlLabel
                                        value="Secondary"
                                        control={<Radio />}
                                        label="Secondary"
                                    />
                                    <FormControlLabel
                                        value="Primary"
                                        control={<Radio />}
                                        label="Primary"
                                    />
                                </RadioGroup>
                                <FormHelperText>{errors.SharingRole ? errors.SharingRole.message : ""}</FormHelperText>
                            </FormControl>
                        )}
                        rules={{
                            required: "Sharing Role is required",
                        }}
                    />
                </Grid>
                <FormHelperText style={{color:"red"}}>{errorMessage}</FormHelperText>
                <Grid item xs={12} sm={12}>
                    <Grid container justify="space-between" alignItems="center">
                        <Grid item>
                            <Button className={classes.submitBtn} variant="contained" type="button" onClick={handleClose}>
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button className={classes.submitBtn} variant="contained" color="primary" type="button" onClick={() => handletripsave()}>
                                Add
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
}
export default  Popup;